class LqdStoriesSlideshowHandler extends elementorModules.frontend.handlers.Base {

    onInit(...args) {

        super.onInit(...args);

        this.initActiveOnHover();
        this.initTimer();

        this.handleDestroy = this.handleDestroy.bind(this);

        elementorFrontend.config.elements.data[this.getModelCID()]?.get('items')?.on('change add remove', this.handleDestroy );

    }

    onElementChange() {
        this.handleDestroy();
    }


    getDefaultSettings() {
        return {
            selectors: {
                activeOnHoverElement: '[data-active-onhover]',
                timerElement: '[data-lqd-timer]',
            }
        }
    }

    getDefaultElements() {
        const selectors = this.getSettings('selectors');
        return {
            $activeOnHoverElement: this.$element.find(selectors.activeOnHoverElement),
            $timerElement: this.$element.find(selectors.timerElement),
        }
    }

    initActiveOnHover() {

        this.elements.$activeOnHoverElement.liquidSetActiveOnhover();

    }

    initTimer() {

        this.elements.$timerElement.liquidTimer();

    }

    onDestroy() {

        this.handleDestroy();

        super.onDestroy();

    }

    handleDestroy() {

        this.handleActiveOnHoverDestroy();
        this.handleTimerDestroy();

        elementorFrontend.config.elements.data[this.getModelCID()]?.get('items')?.off('change add remove', this.handleDestroy);

    }

    handleActiveOnHoverDestroy() {

        if (!this.elements.$activeOnHoverElement.length) return;

        const activeOnHoverData = this.elements.$activeOnHoverElement.data('plugin_liquidSetActiveOnhover');

        if (activeOnHoverData) {
            activeOnHoverData.destroy();
        }

    }

    handleTimerDestroy() {

        if (!this.elements.$timerElement.length) return;

        const timerData = this.elements.$timerElement.data('plugin_liquidTimer');

        if (timerData) {
            timerData.destroy();
        }

    }

}

export default ($element) => {
    elementorFrontend.elementsHandler.addHandler(LqdStoriesSlideshowHandler, { $element });
};